// The download button and the dialog's accessible name both fall back to the
// last segment of the URL when no name is given.
export function documentNameFrom(src: string): string {
  try {
    return decodeURIComponent(new URL(src, window.location.href).pathname)
      .split("/")
      .filter(Boolean)
      .pop() as string;
  } catch {
    return src;
  }
}
